import API, { API_URL } from 'api/API';

import { getUrlQueryString } from 'libs/utils';

interface GetSkycamImageApiParams {
  url?: string;
}

async function getSkycamImageApi({ url }: GetSkycamImageApiParams): Promise<Blob> {
  const queryString = getUrlQueryString({
    url,
  });
  const { data } = await API.get(`${API_URL.SKYW.GET_SKYCAM_IMAGE}?${queryString}`, {
    responseType: 'blob',
  });

  return data;
}

export default getSkycamImageApi;
